import {
  CELLS,
  getDefaultColumnParams,
  preventDisplayTitleOnCell
} from "@/helpers/table.helpers"
import { NumberConvertor } from "@/hooks/useNumberConvertor"
import { ImpactCell } from "@/molecules/ImpactCell"
import { MoreTableCell } from "@/molecules/MoreTableCell"
import { ImageActionsCell } from "../../molecules/ImageActionsCell"
import { ImageNameCell } from "../../molecules/ImageNameCell"
import { ImageTagCell } from "../../molecules/ImageTagCell"
import { InsightsImageCell } from "../../molecules/InsightsImageCell"
import { MoreTableCellDrawer } from "../../molecules/MoreTableCellDrawer"

import type { SortOrder } from "@/atoms"
import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import type { TFunction } from "@/hooks/useTranslation"

export const getPreviewColumnsTable = (
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
) => [
  {
    title: "Image Name",
    className: "displayName-image-tab-template-component",
    render: ImageNameCell,
    onCell: preventDisplayTitleOnCell,
    width: "20%",
    ...getDefaultColumnParams("displayName", sorter),
    sortDirections: ["descend", "ascend", "descend"] as SortOrder[]
  },
  {
    title: "Tag",
    width: "15%",
    render: ImageTagCell,
    ...getDefaultColumnParams("tag")
  }
]

export const getColumnsTable = ({
  sorter,
  t,
  convertors,
  previewMode,
  onRowClick,
  selfHosted
}: {
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
  t: TFunction
  convertors: NumberConvertor
  onRowClick: RowClick
  previewMode?: boolean
  selfHosted?: boolean
}) => {
  const previewColumns = getPreviewColumnsTable(sorter)
  if (previewMode) return previewColumns

  const columns = [
    ...previewColumns,
    {
      title: "Insights",
      render: InsightsImageCell(t),
      width: 125,
      ...getDefaultColumnParams("insights")
    },
    CELLS.getIssuesSummaryCell({ t, convertors, sorter }),
    {
      title: "Apps",
      width: 70,
      className: "center-align-tab-template-component",
      render: ImpactCell({ onRowClick }),
      sortDirections: ["descend", "ascend"] as SortOrder[],
      ...getDefaultColumnParams("applicationsCount", sorter)
    },
    {
      title: "Code Repositories",
      width: "17%",
      render: MoreTableCellDrawer(onRowClick),
      ...getDefaultColumnParams("codeRepositoriesDisplayValue")
    },
    {
      title: "Base Images",
      width: 150,
      render: MoreTableCell,
      ...getDefaultColumnParams("baseImageName")
    },
    {
      title: "SBOM",
      width: 55,
      className: "center-align-tab-template-component",
      ...getDefaultColumnParams("sbomQuery"),
      render: (_: any, record: any) => {
        return ImageActionsCell(record)
      }
    },
    CELLS.getLastDetectedCell({
      entityName: "image",
      t,
      width: 155,
      ...getDefaultColumnParams("lastDetectionData")
    })
  ]

  if (selfHosted) {
    return columns.filter((column) => column.title !== "SBOM")
  }
  return columns
}
